/* eslint-disable quote-props */
module.exports = {
  'Customer Panel': 'Müşteri Paneli',
  'User account management panel.': 'Kullanıcı hesap yönetim paneli.',
  'User Id': 'Kullanıcı Kimliği',
  'Password': 'Parola',
  'Enter user id': 'Kullanıcı kimliğini girin',
  'Enter password': 'Şifre girin',
  'Log In': 'Oturum Aç',
  'Don\'t have an account ?': 'Hesabınız yok mu?',
  'Open Live Account': 'Gerçek Hesap Açın',
  // views/login/index.js
  'Dashboard': 'Anasayfa',
  'Welcome to Customer Panel': 'Müşteri Paneline Hoşgeldiniz',
  'User Accounts': 'Kullanıcı Hesapları',
  'Select the account to be active.': 'Aktif Hesabı Seçin',
  'Account': 'Hesaplar',
  'Name': 'İsim',
  'Equity': 'Eşitlik',
  'Balance': 'Bakiye',
  'Margin': 'Margin',
  'Free Margin': 'Free Margin',
  'Margin Level': 'Margin Level',
  'Profit': 'Kâr',
  'Total Withdrawal': 'Toplam Çekme',
  'All transactions made to date': 'Bugüne kadar yapılan tüm işlemler',
  'Total Deposit': 'Toplam Yatırma',
  'Latest Money Transfers': 'Son Para Transferleri',
  'Last transfer transactions': 'Son transfer işlemleri',
  'Login': 'Oturum',
  'PSP': 'PSP',
  'Date': 'Tarih',
  'Amount': 'Miktar',
  'Status': 'Durum',
  'Deposit': 'Yatırma',
  'Withdrawal': 'Çekme',
  'Open Positions': 'Açık Pozisyonlar',
  'Your open transactions': 'Senin açık pozisyonların',
  'No Record': 'Kayıt Yok',
  'You have no open orders': 'Açık emir yok',
  'Order': 'Sipariş',
  'Time': 'Zaman',
  'Type': 'Türü',
  'Size': 'Boyut',
  'Symbol': 'Sembol',
  'Price': 'Fiyat',
  'Swap': 'Takas',
  'You have no pending orders': 'Bekleyen siparişiniz yok',
  'Pending Orders': 'Bekleyen emirler',
  'Your pending transactions': 'Beklemedeki işlemleriniz',
  'Account History': 'Hesap Geçmişi',
  'My Documents': 'Benim Dökümanlarım',
  'Research': 'Araştırma',
  'Logout': 'Çıkış Yap',
  'ACCOUNTS': 'HESAPLAR',
  'COMMON': 'ORTAK',
  'Withdrawal History': 'Çekme Geçmişi',
  'Recent successful withdrawals': 'Son başarılı para çekme işlemleri',
  'You have no successful withdrawal transactions': 'Başarılı bir para çekme işleminiz yok',
  'Deposit History': 'Yatırma Geçmişi',
  'You have no successful deposit transactions': 'Başarılı bir para yatırma işleminiz yok.',
  // views/layout/sidebar.js
};
